import {Log} from '@aboutyou/mlm';

export const loadClientIconSVGLoader =
  (assetsUrl: string | undefined) => async (url: string) => {
    const resolvedUrl =
      url.startsWith('/') && assetsUrl ? `${assetsUrl}${url}` : url;
    try {
      const res = await window.fetch(resolvedUrl);
      // do not log to monitoring for canceled requests
      if (res.status === 0) {
        return undefined;
      }
      return await res.text();
    } catch (error) {
      if (error?.code === 'ECONNABORTED') {
        // do not log to monitoring for timeouts
        return undefined;
      }

      Log.error('@aboutyou/bootstrap', `could not load icon from ${url}`, {
        error,
      });

      return undefined;
    }
  };
